import { render } from "./AdjektivPractice.vue?vue&type=template&id=25df1070&scoped=true"
import script from "./AdjektivPractice.vue?vue&type=script&lang=js"
export * from "./AdjektivPractice.vue?vue&type=script&lang=js"

import "./AdjektivPractice.vue?vue&type=style&index=0&id=25df1070&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25df1070"]])

export default __exports__